import { render } from "./DocBlock.vue?vue&type=template&id=2159200c&scoped=true"
import script from "./DocBlock.vue?vue&type=script&lang=js"
export * from "./DocBlock.vue?vue&type=script&lang=js"

import "./DocBlock.vue?vue&type=style&index=0&id=2159200c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2159200c"]])

export default __exports__